import {ParsedUrlQuery} from 'querystring';
import {parseDataKey} from '../util/parseDataKey';

export function getLandingListQuery(query?: ParsedUrlQuery) {
  const validParams = query?.pathParams;
  if (!validParams || validParams.length === 0) {
    return {};
  }
  if (typeof validParams === 'string') {
    return {
      dataKey: parseDataKey(validParams),
    };
  }
  const themeKeyIndex = validParams.findIndex(param => param === 'theme');
  const dataKeyList =
    themeKeyIndex > 0 ? validParams.slice(0, themeKeyIndex) : validParams;
  return {
    dataKey: parseDataKey(dataKeyList),
    themeKeywordUid:
      themeKeyIndex > 0 ? validParams[themeKeyIndex + 1] : undefined,
  };
}
